import { factory } from '../../../utils/apiThunkFactory';

export const resetWhiteboard = factory.post('whiteboard/resetWhiteboard', '/api/whiteboard/reset');